/* @flow */
import * as React from 'react';
import styled from 'styled-components';

import { Box } from '@sonyged/proc-ui';
import { css } from '@styled-system/css';

type Props = {
  gradientHeight?: number | number[],
  children: React.Node,
};
export function ContentScroll(props: Props) {
  let { children, gradientHeight = 0, ...rest } = props;
  return (
    <Container {...rest} gradientHeight={gradientHeight}>
      <ScrollArea py={gradientHeight}>{children}</ScrollArea>
    </Container>
  );
}

const Container = styled(Box)(
  {
    display: 'flex',
    flexDirection: 'column',
    maskImage: 'linear-gradient(to top, transparent 0%, black 12px, black calc(100% - 12px),  transparent 100%)',
  },
  ({ gradientHeight }) => {
    if (!gradientHeight) return;
    if (!(gradientHeight instanceof Array)) gradientHeight = [gradientHeight];
    return {
      maskImage: gradientHeight.map(
        h => `linear-gradient(to top, transparent 0%, black ${h}px, black calc(100% - ${h}px),  transparent 100%)`
      ),
    };
  }
);

const ScrollArea = styled(Box)(
  css({
    overflow: 'auto',
    flex: 1,
    minHeight: 0,

    '&::-webkit-scrollbar': {
      display: 'none',
    },
  })
);
